import React from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { selectors as brandSelectors } from "../../../../redux/brand";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";

const StyledInstructions = styled.div`
  margin: 10px 0 10px 0;
`;

const Instructions = ({ userDecideInstructions }) => {
  if (userDecideInstructions) {
    return (
      <div>
        <StyledInstructions>
          <ReactMarkdown
            linkTarget="_blank"
            rehypePlugins={[rehypeRaw]}
          >
            {userDecideInstructions}
          </ReactMarkdown>
        </StyledInstructions>
      </div>
    );
  }
  return null;
};

const mapStateToProps = state => ({
  userDecideInstructions: brandSelectors.getBrandValue(
    state,
    "UserDecide.instructions",
    false
  )
});

export default connect(mapStateToProps)(Instructions);
